/* eslint-disable camelcase */
import Http from './http'

import dayjs from 'dayjs'
import moment from 'moment-timezone'

const prepareOfferQuery = (offers) => {
    let extraQuery = ''
    if (typeof offers === 'object') {
        offers.forEach((off) => {
            extraQuery += `&offer=${off}`
        })
    } else {
        extraQuery = `&offer=${offers}`
    }
    return extraQuery;
}

export const getKpiApprovedStats = (start_of, end_of, token, offer = '') => {

    let extraParams = '';
    if (offer !== '') {
        extraParams = `&offer=${offer}`
    }
    return Http.get(`/api/report/kpi-date-based?start_date=${start_of}&end_date=${end_of}${extraParams}`, { headers: { Authorization: `Bearer ${token}` } })
}

export const getKpiStats = (token, offer = '') => {
    let extraParams = '';
    if (offer !== '') {
        extraParams = `?offer=${offer}`
    }
    return Http.get(`/api/report/kpi${extraParams}`, { headers: { Authorization: `Bearer ${token}` } })
}

export const getSalesByHour = (day, offers, token) => {

    const startOfDay = dayjs(day).subtract(24, 'hour').valueOf();
    const endOfDay = dayjs(day).endOf('day').valueOf();

    let extraQuery = prepareOfferQuery(offers);

    return Http.get(`/api/report/sales/hour?start_date=${startOfDay}&end_date=${endOfDay}&status=paid${extraQuery}`, { headers: { Authorization: `Bearer ${token}` } })
}

export const getSalesByDay = (startDate, endDate, offers, token) => {

    let extraQuery = prepareOfferQuery(offers);

    const startDayUTC = moment(moment(startDate).format("YYYY-MM-DD 22:00:00")).tz("America/Sao_Paulo").startOf('day').utc().format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]");
    const endDayUTC = moment(moment(endDate).format("YYYY-MM-DD 22:00:00")).tz("America/Sao_Paulo").endOf('day').utc().format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]");

    return Http.get(`/api/report/sales/day?start_date=${startDayUTC}&end_date=${endDayUTC}&status=paid${extraQuery}`, { headers: { Authorization: `Bearer ${token}` } })
}

export const getSales7Days = (offers, token) => {

    const starOfToday = dayjs().subtract(7, 'day').startOf('day').valueOf();
    const endOfToday = dayjs().valueOf();

    let extraQuery = prepareOfferQuery(offers);

    return Http.get(`/api/report/sales?start_date=${starOfToday}&end_date=${endOfToday}&status=paid${extraQuery}`, { headers: { Authorization: `Bearer ${token}` } })

}

export const getSales30Days = (offers, token) => {

    const starOfToday = dayjs().subtract(30, 'day').startOf('day').valueOf();
    const endOfToday = dayjs().valueOf();

    let extraQuery = prepareOfferQuery(offers);

    return Http.get(`/api/report/sales?start_date=${starOfToday}&end_date=${endOfToday}&status=paid${extraQuery}`, { headers: { Authorization: `Bearer ${token}` } })

}

export const getSales15Days = (offers, token) => {

    const starOfToday = dayjs().subtract(15, 'day').startOf('day').valueOf();
    const endOfToday = dayjs().valueOf();

    let extraQuery = prepareOfferQuery(offers);

    return Http.get(`/api/report/sales?start_date=${starOfToday}&end_date=${endOfToday}&status=paid${extraQuery}`, { headers: { Authorization: `Bearer ${token}` } })

}

export const getTodaySales = (offers, token) => {

    const starOfToday = dayjs().subtract(24, 'hour').valueOf();
    const endOfToday = dayjs().endOf('day').valueOf();

    let extraQuery = ''
    if (typeof offers === 'object') {
        offers.forEach((offer) => {
            extraQuery + `&offer=${offer}`
        })
    } else {
        extraQuery = `&offer=${offers}`
    }

    return Http.get(`/api/report/sales?start_date=${starOfToday}&end_date=${endOfToday}&status=paid${extraQuery}`, { headers: { Authorization: `Bearer ${token}` } })
}

export const getPastSales = () => {
    return [];
}